module.exports = __webpack_public_path__ + "img/frsc.508112f6.png";